import VueGtag from "vue-gtag";
host.plugins.register({
    // #region Vars
    name: "288a.web.gtag",
    // #endregion
    // #region Startup
    startup() {
        if (this.$host.config.googleTag && this.$host.config.googleTag.id) {
            //Tag
            this.$host.app.use(VueGtag, {
                config: { id: host.config.googleTag.id },
                enabled: utils.getCookieValue("288a.CookieStatistik") == "yes",
            }, this.$host.router);
            //Events
            this.$host.eventBus.on("cookie_consent_changed", async (e) => {
                //Fin
                let tTag = this.$host.app.config.globalProperties.$gtag;
                //Set
                if (utils.getCookieValue("288a.CookieStatistik") == "yes") {
                    tTag.optIn();
                }
                else {
                    tTag.optOut();
                }
            });
        }
    }
    // #endregion
});
